import React from 'react';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';

export default function SortArrow({ sort, col }) {
  if (sort.key !== col) {
    return <ChevronsUpDown className="inline-block h-3 w-3 text-slate-400 ml-1 align-[-2px]" />;
  }

  const Icon = sort.dir === 1 ? ArrowUp : ArrowDown;
  return <Icon className="inline-block h-3 w-3 text-brand-600 ml-1 align-[-2px]" />;
}
